module.exports = __webpack_public_path__ + "img/arrow.128b6f3e.png";